import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _cellSpansBySize, _imagePlaceholderAspe;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import Content from './components/Content';
import { Layout, Cell } from '../Layout';
import Proportion from '../Proportion';
import { SIZES } from './constants';
import { st, classes } from './MarketingLayout.st.css';
import colors from '../colors.scss';
var cellSpansBySize = (_cellSpansBySize = {}, _defineProperty(_cellSpansBySize, SIZES.small, {
  image: 2,
  spacer: 1,
  content: 9
}), _defineProperty(_cellSpansBySize, SIZES.medium, {
  image: 4,
  spacer: 1,
  content: 7
}), _defineProperty(_cellSpansBySize, SIZES.large, {
  image: 5,
  spacer: 1,
  content: 6
}), _cellSpansBySize);
var imagePlaceholderAspectRatioBySize = (_imagePlaceholderAspe = {}, _defineProperty(_imagePlaceholderAspe, SIZES.small, 1), _defineProperty(_imagePlaceholderAspe, SIZES.medium, 282 / 188), _defineProperty(_imagePlaceholderAspe, SIZES.large, 360 / 240), _imagePlaceholderAspe);
/** Marketing layout is a layout designed to promote new features or display first time visit.
 * Component has title, description, action and illustration areas. */

var MarketingLayout = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(MarketingLayout, _React$PureComponent);

  var _super = _createSuper(MarketingLayout);

  function MarketingLayout() {
    var _this;

    _classCallCheck(this, MarketingLayout);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_renderSpacerCell", function (span) {
      return /*#__PURE__*/React.createElement(Cell, {
        key: "spacer",
        span: span
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_renderImagePlaceholder", function () {
      var size = _this.props.size;
      return /*#__PURE__*/React.createElement(Proportion, {
        aspectRatio: imagePlaceholderAspectRatioBySize[size]
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.imagePlaceholder
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "_renderImageCell", function (span) {
      var _this$props = _this.props,
          image = _this$props.image,
          imageBackgroundColor = _this$props.imageBackgroundColor;
      return /*#__PURE__*/React.createElement(Cell, {
        key: "image",
        span: span
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.imageWrapper
      }, imageBackgroundColor && /*#__PURE__*/React.createElement("div", {
        className: classes.imageBackground,
        style: {
          backgroundColor: colors[imageBackgroundColor] || imageBackgroundColor
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: classes.imageContainer
      }, typeof image === 'string' ? /*#__PURE__*/React.createElement("img", {
        src: image,
        width: "100%"
      }) : image || _this._renderImagePlaceholder())));
    });

    _defineProperty(_assertThisInitialized(_this), "_renderContentCell", function (span) {
      var _this$props2 = _this.props,
          size = _this$props2.size,
          actions = _this$props2.actions,
          title = _this$props2.title,
          description = _this$props2.description;
      return /*#__PURE__*/React.createElement(Cell, {
        key: "content",
        span: span
      }, /*#__PURE__*/React.createElement(Content, {
        size: size,
        actions: actions,
        title: title,
        description: description
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "_renderContent", function () {
      var _this$props3 = _this.props,
          inverted = _this$props3.inverted,
          size = _this$props3.size;
      var cellSpans = cellSpansBySize[size];

      var spacerCell = _this._renderSpacerCell(cellSpans.spacer);

      var imageCell = _this._renderImageCell(cellSpans.image);

      var contentCell = _this._renderContentCell(cellSpans.content);

      return /*#__PURE__*/React.createElement(Layout, null, inverted ? [imageCell, contentCell, spacerCell] : [contentCell, spacerCell, imageCell]);
    });

    return _this;
  }

  _createClass(MarketingLayout, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          size = _this$props4.size,
          inverted = _this$props4.inverted,
          actions = _this$props4.actions,
          dataHook = _this$props4.dataHook,
          imageBackgroundColor = _this$props4.imageBackgroundColor;
      return /*#__PURE__*/React.createElement("div", {
        className: st(classes.root, {
          size: size,
          inverted: inverted,
          withActions: !!actions,
          withImageBackground: !!imageBackgroundColor
        }),
        "data-hook": dataHook
      }, this._renderContent());
    }
  }]);

  return MarketingLayout;
}(React.PureComponent);

_defineProperty(MarketingLayout, "displayName", 'MarketingLayout');

_defineProperty(MarketingLayout, "propTypes", {
  /** Hook for testing purposes. */
  dataHook: PropTypes.string,

  /** Image URL or custom element. */
  image: PropTypes.node,

  /** Image area background color. Can be a keyword from color palette or any supported CSS color value (Hex, RGB, etc.) */
  imageBackgroundColor: PropTypes.string,

  /** Size of the marketing layout. */
  size: PropTypes.oneOf(['small', 'medium', 'large']),

  /** Invert marketing layout (with image displayed on the left). */
  inverted: PropTypes.bool,

  /** Marketing layout actions. */
  actions: PropTypes.node,

  /** Title as a string or custom element. */
  title: PropTypes.node,

  /** Description as a string or custom element. */
  description: PropTypes.node
});

_defineProperty(MarketingLayout, "defaultProps", {
  size: SIZES.small,
  inverted: false
});

export default MarketingLayout;